import { render, staticRenderFns } from "./othersLayout.vue?vue&type=template&id=0158d1b1"
import script from "./othersLayout.vue?vue&type=script&lang=js"
export * from "./othersLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports